'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var QuestionAlertIcon = function QuestionAlertIcon(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutProperties(_ref, ['fill']);

  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      'svg',
      { style: { display: 'block' }, width: '100%', height: '100%', viewBox: '0 0 16 16' },
      _react2.default.createElement('path', { fill: fill, fillRule: 'evenodd', d: 'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zm0-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-.9-7.5c.2-.3.5-.5.9-.5.6 0 1 .4 1 1 0 .3-.1.4-.6.7C7.8 7.1 7 7.7 7 9v1h2V9c0-.2 0-.3.5-.6.6-.4 1.5-1 1.5-2.4 0-1.7-1.3-3-3-3-1.1 0-2.1.6-2.6 1.5l-.5.9 1.7 1 .5-.9z' })
    )
  );
};

QuestionAlertIcon.propTypes = _extends({}, _Icon2.default.propTypes);

QuestionAlertIcon.defaultProps = _extends({}, _Icon2.default.defaultProps, {
  size: 'small',
  fill: _theme2.default.colors.question
});

exports.default = QuestionAlertIcon;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/QuestionAlertIcon.js
// module id = 585
// module chunks = 0